"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import classes from './styles.module.css.mjs';
import { Tag } from './Tag.mjs';

const TagPlaceholder = forwardRef(function({ children, className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    Tag,
    {
      ref,
      className: clsx(classes.tagPlaceholder, !!props?.onClick && classes.tagPlaceholder__clickable, className),
      ...props,
      children
    }
  );
});

export { TagPlaceholder };
